import React, { useRef, useEffect } from "react";

const Wave = ({ data }) => {
    const canvasRef = useRef(null);

    // 설정값
    const CANVAS_WIDTH = 2177;
    const CANVAS_HEIGHT = 320;
    const GRID_SIZE = 32;
    const DURATION = 10; // 10초
    const SAMPLES_PER_SECOND = 250;
    const TOTAL_SAMPLES = DURATION * SAMPLES_PER_SECOND; // 2500개
    
    // const processWaveData = (dataArray) => {
    //     if (!dataArray || !Array.isArray(dataArray)) return [];

    //     const processedData = [];
    //     const AMPLITUDE_LIMIT = 100; // 캔버스 기준에서 벗어나지 않도록 제한

    //     dataArray.forEach((item) => {
    //         if (item.wave && Array.isArray(item.wave) && item.wave.length > 0) {

    //             // ※ -2147483648 값은 페이스메이커 값으로 치환해서 처리해서 보여줘야 함. 추후 저 값이 변동되거나 했을 때는 backend와 협의 필요.
    //             //const waveData = item.wave.map(Number);
    //             const waveData = item.wave.map(Number).map((value, index, array) => {
    //                 if (value === -2147483648) {
    //                     // 이전 값이 있고 유효한 경우
    //                     if (index > 0 && array[index - 1] !== -2147483648) {
    //                         return array[index - 1];
    //                     }
    //                     // 다음 값이 있고 유효한 경우
    //                     else if (index < array.length - 1 && array[index + 1] !== -2147483648) {
    //                         return array[index + 1];
    //                     }
    //                     // 둘 다 없으면 0으로 설정
    //                     else {
    //                         return 0;
    //                     }
    //                 }
    //                 return value;
    //             });
    //             // const minValue = Math.min(...waveData);
    //             // const maxValue = Math.max(...waveData);
    //             // const centerValue = (minValue + maxValue) / 2;
    //             const defaultMinY = -150
    //             const defaultMaxY = 300
    //             let minValue = Math.min(...waveData);
    //             let maxValue = Math.max(...waveData);
    //             minValue = Math.min(minValue, defaultMinY)
    //             maxValue = Math.max(maxValue, defaultMaxY)
    //             const centerValue = (minValue + maxValue) / 2;

    //             // 정규화
    //             const normalized = waveData.map(v => v - centerValue);

    //             // 최대 진폭 계산 후 스케일링 비율 결정
    //             const maxAbs = Math.max(...normalized.map(Math.abs));
    //             const scale = maxAbs > AMPLITUDE_LIMIT ? AMPLITUDE_LIMIT / maxAbs : 1;

    //             // 스케일링 및 클리핑
    //             normalized.forEach(value => {
    //                 processedData.push(value * scale);
    //             });
    //         } else {
    //             // wave 데이터가 없는 경우 250개의 null 값으로 공백 표현
    //             for (let i = 0; i < SAMPLES_PER_SECOND; i++) {
    //                 processedData.push(null);
    //             }
    //         }
    //     });

    //     return processedData;
    // };

    const processWaveData = (dataArray) => {
        if (!dataArray || !Array.isArray(dataArray)) return [];

        const AMPLITUDE_LIMIT = 100;
        
        // ✅ 모든 데이터를 먼저 수집하고 -2147483648 처리
        const allWaveData = [];
        
        dataArray.forEach((item) => {
            if (item.wave && Array.isArray(item.wave) && item.wave.length > 0) {
                const waveData = item.wave.map(Number).map((value, index, array) => {
                    if (value === -2147483648) {
                        if (index > 0 && array[index - 1] !== -2147483648) {
                            return array[index - 1];
                        } else if (index < array.length - 1 && array[index + 1] !== -2147483648) {
                            return array[index + 1];
                        } else {
                            return 0;
                        }
                    }
                    return value;
                });
                allWaveData.push(...waveData);
            } else {
                // wave 데이터가 없는 경우 250개의 null 값
                for (let i = 0; i < SAMPLES_PER_SECOND; i++) {
                    allWaveData.push(null);
                }
            }
        });

        // ✅ null이 아닌 값들만 추출하여 전체 범위 계산
        const validValues = allWaveData.filter(v => v !== null && v !== undefined);
        
        if (validValues.length === 0) return allWaveData;

        const defaultMinY = -150;
        const defaultMaxY = 300;
        let minValue = Math.min(...validValues);
        let maxValue = Math.max(...validValues);
        minValue = Math.min(minValue, defaultMinY);
        maxValue = Math.max(maxValue, defaultMaxY);
        const centerValue = (minValue + maxValue) / 2;

        // ✅ 전체 데이터를 한 번에 정규화
        const normalized = allWaveData.map(v => {
            if (v === null || v === undefined) return null;
            return v - centerValue;
        });

        // 최대 진폭 계산
        const validNormalized = normalized.filter(v => v !== null);
        const maxAbs = Math.max(...validNormalized.map(Math.abs));
        const scale = maxAbs > AMPLITUDE_LIMIT ? AMPLITUDE_LIMIT / maxAbs : 1;
        
        const processedData = normalized.map(value => {
            if (value === null) return null;
            return value * scale;
        });

        return processedData;
    };

    // Canvas에 그리드 그리기
    const drawGrid = (ctx) => {
        //ctx.strokeStyle = "rgba(94, 94, 94, 0.8)";
        ctx.strokeStyle = "#FF8383";
        ctx.lineWidth = 1;

        // 0.5px 오프셋으로 선이 픽셀 경계에 정확히 맞도록 함
        ctx.translate(0.5, 0.5);

        // 세로 선
        for (let x = 0; x <= CANVAS_WIDTH; x += GRID_SIZE) {
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, CANVAS_HEIGHT - 1);
            ctx.stroke();
        }

        // 가로 선
        for (let y = 0; y < CANVAS_HEIGHT; y += GRID_SIZE) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(CANVAS_WIDTH - 1, y);
            ctx.stroke();
        }

        // 맨 아래 선 추가
        ctx.beginPath();
        ctx.moveTo(0, CANVAS_HEIGHT - 1);
        ctx.lineTo(CANVAS_WIDTH - 1, CANVAS_HEIGHT - 1);
        ctx.stroke();

        // 중앙선 강조
        //  const centerY = CANVAS_HEIGHT / 2;
        // ctx.strokeStyle = "#999";
        // ctx.lineWidth = 1;
        // ctx.beginPath();
        // ctx.moveTo(0, centerY);
        // ctx.lineTo(CANVAS_WIDTH - 1, centerY);
        // ctx.stroke();

        // translate 원래대로 복원
        ctx.translate(-0.5, -0.5);
    };

    // 웨이브폼 그리기
    const drawWaveform = (ctx, waveData) => {
        if (!waveData || waveData.length === 0) return;

        ctx.strokeStyle = "#000";
        //ctx.strokeStyle = "#FF8383";
        ctx.lineWidth = 2;

        const centerY = CANVAS_HEIGHT / 2;
        const xStep = CANVAS_WIDTH / Math.max(waveData.length - 1, 1);

        // 연속된 선분들을 그리기 위해 path를 나누어서 처리
        let currentPath = null;

        for (let i = 0; i < waveData.length; i++) {
            const x = i * xStep;
            
            if (waveData[i] !== null && waveData[i] !== undefined) {
                const y = centerY - waveData[i];
                
                if (currentPath === null) {
                    // 새로운 path 시작
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    currentPath = true;
                } else {
                    ctx.lineTo(x, y);
                }
            } else {
                // null 값을 만나면 현재 path를 그리고 종료
                if (currentPath !== null) {
                    ctx.stroke();
                    currentPath = null;
                }
            }
        }

        // 마지막 path가 있으면 그리기
        if (currentPath !== null) {
            ctx.stroke();
        }
    };

    // Canvas 렌더링
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

        // 그리드 그리기
        drawGrid(ctx);

        // 데이터 전처리 후 웨이브폼 그리기
        if (data && Array.isArray(data) && data.length > 0) {
            const processedWaveData = processWaveData(data);
            //console.log('processedWaveData',processedWaveData);
            drawWaveform(ctx, processedWaveData);
        }
    }, [data]);

    return (
        <canvas
            ref={canvasRef}
            width={CANVAS_WIDTH}
            height={CANVAS_HEIGHT}
            className="block"
        />
    );
};

export default Wave;